module.exports = __webpack_public_path__ + "static/media/video-icon-black.6538dc90.svg";